const getTotpSecretFromUrl = (url: string) => {
  const paramsString = (url || '').split('?')[1];
  const urlSearchParams = new URLSearchParams(paramsString);
  const params = Object.fromEntries(urlSearchParams.entries());

  return params?.secret || '';
};

export default getTotpSecretFromUrl;
